import { TermsSection } from './sections';

export const TncRoute = () => (
  <TermsSection />
);
